import styled, { css } from 'styled-components';

import { mediaQuery } from '../../styles/mixin';

export const NotesTextarea = styled.textarea<{ isLoading?: boolean }>`
    font-size: ${({ theme }) => theme.fontSizes[2]};
    line-height: 1.33333;
    padding: 1rem 1rem 0.25rem 1rem;
    border: none;
    border-radius: 0.375rem;
    color: ${({ theme }) => theme.colors.fontPrimary};
    height: 100%;
    width: 100%;
    resize: none;
    min-height: 2rem;
    max-height: 10rem;
    cursor: ${({ disabled }) => (disabled ? 'wait' : 'text')};
    background: ${({ isLoading }) =>
        isLoading
            ? // eslint-disable-next-line max-len
              'linear-gradient(white 30%, rgba(255, 255, 255, 0)),radial-gradient(farthest-side at 50% 0,rgba(0, 0, 0, 0.3),rgba(0, 0, 0, 0))'
            : 'none'};
    background-repeat: no-repeat;
    background-color: rgba(0, 0, 0, 0.05);
    background-size: 100% 40px, 100% 14px;
    background-attachment: local, scroll;
    box-shadow: 0 0 0 1px rgb(0 0 0 / 10%);
    transition: var(--notes-transition);
    ${mediaQuery(
        1,
        css`
            max-height: 20rem;
        `
    )}

    &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 40px;
        background: linear-gradient(white 30%, rgba(255, 255, 255, 0));
    }

    &:disabled {
        user-select: none;
        border-radius: 0.25rem;
        background: #0000001d;
    }

    &::placeholder {
        color: #8c8c8c;
        opacity: 1;
    }
`;

export const NotesOverflowShade = styled.div<{ shown?: boolean }>`
    --notes-shade-height: 4rem;

    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: var(--notes-shade-height);
    background: linear-gradient(
        rgba(255, 255, 255, 0),
        rgba(255, 255, 255, 1)
            calc(var(--notes-shade-height) - var(--notes-padding))
    );
    z-index: 1;
    opacity: ${({ shown }) => (shown ? 1 : 0)};
    pointer-events: none;
    transition: var(--notes-transition);
`;

export const NotesLoading = styled.div<{ shown?: boolean }>`
    position: absolute;
    top: 4rem;
    left: 50%;
    height: 100%;
    transform: translateX(-50%);
    user-select: none;
    cursor: ${({ shown }) => (shown ? 'wait' : 'initial')};
    opacity: ${({ shown }) => (shown ? 1 : 0)};
    pointer-events: none;
    transition: var(--notes-transition);
`;
